import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import InstantAuth from "Login/InstantAuth";

import FnrErrorBoundary from "UI/FnrErrorBoundary";
import FnrOverlayBackdrop from "UI/FnrOverlay/FnrOverlayBackdrop.js";
import { CSSColorVariables } from "UI/colors";

import AppCrashFallback from "./AppCrashFallback";
import BoardTheBus from "./BoardTheBus";
import GlobalComponents from "./GlobalComponents/GlobalComponents";
import HandleDevEnvPageStructure from "./HandleDevEnvPageStructure";
import Providers from "./Providers";
import Routes from "./Routes";

export default function FlocknoteApp() {
  return (
    <Router>
      <Providers>
        <FnrErrorBoundary
          boundaryName="FlocknoteApp"
          fallbackRender={({ error }) => <AppCrashFallback error={error} />}
        >
          <CSSColorVariables />
          <HandleDevEnvPageStructure />
          <BoardTheBus />
          <Routes />
          <FnrOverlayBackdrop />
          <InstantAuth />
          <GlobalComponents />
        </FnrErrorBoundary>
      </Providers>
    </Router>
  );
}
